<template>
  <div>
    <span class="dualstate dualstate-switcher">
      <input type="radio" :value="false" v-model="radioChecked">
      <input type="radio" :value="true" v-model="radioChecked">
      <i aria-hidden="true"/>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    radioChecked: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="sass" scoped>
.dualstate
  margin-top: 5px
  position: relative
  display: inline-block
  & > input[type="radio"]
    position: absolute
    left: 0
    top: 0
    width: 18px
    height: 18px
    margin: 0
    padding: 0
    opacity: 0
    & + i
      position: relative
      display: inline-block
      width: 18px
      height: 18px
      vertical-align: top
      &, &:before, &:after
        transition: all 0.3s
    &:first-child
      z-index: 10
      &:checked
        z-index: 0
    &:checked
      & + input[type="radio"]
        z-index: 10
      & + i
        & + label, & + label + label,
        & + label + label + label
          display: none
  &-switcher
    & > input[type="radio"]
      width: 60px
      height: 50px
      left: -3px
      top: -1px

      & + i
        width: 50px
        height: 20px
        margin-top: 2px
        background-color: var(--color-gray-medium-light)
        border-radius: 8px
        &:before
          content: ' '
          position: absolute
          left: 1px
          top: 1px
          display: block
          width: 18px
          height: 18px
          background-color: var(--color-background-light)
          border-radius: 50%
          box-shadow: 0 1px 8px 1px rgba(0, 0, 0, 0.3)
      &:checked
        & + i
          background-color: var(--color-primary)
          &:before
            left: 30px
            background-color: white
</style>
